import React from 'react';
import TopNavbar from './TopNavbar';
import Sidebar from './Sidebar';

const GuideBot = React.lazy(() => import('../ui/GuideBot'));

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const layoutStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    background: 'transparent',
  };

  const mainContainerStyle: React.CSSProperties = {
    display: 'flex',
    flex: 1,
    maxWidth: 'none',
    margin: '0 auto',
    width: '100%',
  };

  const pageStyle: React.CSSProperties = {
    flex: 1,
    padding: '2.25rem',
    minWidth: 0,
  };

  return (
    <div style={layoutStyle}>
      <TopNavbar />
      <div style={mainContainerStyle}>
        <Sidebar />
        <main style={pageStyle}>
          {children}
        </main>
      </div>
      <React.Suspense fallback={null}>
        <GuideBot />
      </React.Suspense>
    </div>
  );
};

export default AppLayout;
